const genRandom = () => Math.floor(Math.random() * 1000000);
/**
 * Create unique ID for element references inside components
 */
const uniqueId = (identifier) => {
  const idPart = identifier ? `${identifier}-` : '';
  return `${idPart}${genRandom()}-${genRandom()}`;
};

export { uniqueId as u };
